import { render, staticRenderFns } from "./Sounds.vue?vue&type=template&id=3360eee6&"
import script from "./Sounds.vue?vue&type=script&lang=js&"
export * from "./Sounds.vue?vue&type=script&lang=js&"
import style0 from "./Sounds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports